<script>
import { Bar } from "vue-chartjs";
const options = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: "bottom",
  },
  animation: {
    duration: 1,
    onComplete: function () {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;
      ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';

      this.data.datasets.forEach(function (dataset, i) {
        var meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach(function (bar, index) {
          var data = dataset.data[index];
          ctx.fillText(data, bar._model.x, bar._model.y - 5);
        });
      });
    }
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          callback: function (value) {
            if (value.length > 12) {
              return value.substr(0, 12) + "..."; //truncate
            } else {
              return value;
            }
          },
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
          stepSize: 100,
        },
      },
    ],
  },
};
export default {
  extends: Bar,
  props: ["chartData", "options"],
  mounted() { },
  watch: {
    chartData: {
      handler(n, o) {
        this.renderChart(n, options);
      },
      deep: true,
    },
  },
};
</script>


